<button
  mat-stroked-button
  (click)="onClick()"
  [attr.enabled]="popupEnabled()"
  [attr.aria-label]="label()"
  [matTooltip]="label()"
  [matTooltipDisabled]="popupEnabled()"
  #stateTooltip="matTooltip"
>
  <mat-icon>{{ icon() }}</mat-icon>
  <span label>
    <span>{{ label() }}</span>
    @if (showAmount()) {
      <span> ({{ stockAmount() | number }})</span>
    }
  </span>
</button>

<ng-template #stockPopup>
  <div mat-dialog-title>
    <h4>Location Stock</h4>
  </div>
  <mat-dialog-content details>
    <ideal-image [src]="thumbnailUrl()"></ideal-image>
    <ideal-product-id-label [productId]="id()"></ideal-product-id-label>
    <ideal-product-short-description [productId]="id()"></ideal-product-short-description>
  </mat-dialog-content>
  <mat-dialog-content>
    <ideal-item-stock [itemId]="id()" />
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button mat-dialog-close>Close</button>
  </mat-dialog-actions>
</ng-template>
